import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const DiamondEmptyOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function DiamondEmptyOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path fillRule="evenodd" clipRule="evenodd" d="M12 .03c-1.51 0-3.03.58-4.18 1.73L1.74 7.82c-2.32 2.31-2.32 6.07 0 8.39l6.03 6.01A5.958 5.958 0 0 0 12 23.97c1.53 0 3.06-.58 4.23-1.75l6.03-6.01c2.32-2.31 2.32-6.07 0-8.39l-6.08-6.06A5.924 5.924 0 0 0 12 .03Zm0 2c1.05 0 2.03.41 2.77 1.15l6.08 6.06A3.91 3.91 0 0 1 22 12.02c0 1.05-.41 2.04-1.15 2.78l-6.03 6.01A3.98 3.98 0 0 1 12 21.98a3.94 3.94 0 0 1-2.82-1.17L3.15 14.8A3.91 3.91 0 0 1 2 12.02c0-1.05.41-2.04 1.15-2.78l6.08-6.06c.74-.74 1.73-1.15 2.77-1.15Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default DiamondEmptyOutlined;